// @core/api/endpoints/resource/list_recent_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRecentResourcesResponse,
} from '../../../types/resource';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/resource';

/**
 * List recently linked resources
 * Returns resources that have been recently linked or referenced, useful for displaying a 'Recent' section in the UI. Filterable by resource type and product.
 */
export async function ListRecentResources(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRecentResourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/recent`;
  const requestOptions = options;
  return client.get<ListRecentResourcesResponse>(requestPath, { ...requestOptions, params });
}
